export default __webpack_public_path__ + "static/media/close-icon.f5294846.svg";